import React, { useState } from 'react';
import classnames from 'classnames';
import { SiteHeader } from '@buzzfeed/react-components';
import { CANONICAL_ROOT } from '../constants/upstreams';
import { withTranslation } from '../i18n';
import { getLanguageFromEdition } from '../utils/localization';
import { usePageviewTracking } from '../hooks/analytics/usePageviewTracking';
import { usePerformanceTracking } from '../hooks/analytics/usePerformanceTracking';
import { useNavTracking } from '../hooks/analytics/useNavTracking';
import { fetchAPI } from '../utils/initialProps';
import styles from './index.scss';

import ConsentManagement from '../components/ConsentManagement';
import TrophyList from '../components/TrophyList';
import TrophyPageHeader from '../components/TrophyPageHeader';
import TrophiesUnsupported from '../components/TrophiesUnsupported';
import ABeagleProvider from '../components/ABeagleProvider';
import TimeSpentTracking from '../components/TimeSpentTracking';


function filterTrophies(trophies, filterString) {
  if (filterString === 'earned') {
    return trophies.filter(t => t.earned === true);
  }

  if (filterString === 'unearned') {
    return trophies.filter(t => t.earned === false);
  }

  return trophies;
}

function Page({ user, points, trophies = [], header }) {
  usePageviewTracking({});
  usePerformanceTracking({});
  useNavTracking();

  const [trophyFilter, setTrophyFilter] = useState('all');

  const handleTrophyFilterChange = value => setTrophyFilter(value);

  const filteredTrophies = filterTrophies(trophies, trophyFilter);
  const trophyCount = filterTrophies(trophies, 'earned').length;

  if (!user.isCommunityUser) {
    return <TrophiesUnsupported {...user} />;
  }

  return (
    <ABeagleProvider pageProps={user} edition={'en-us'}>
      <ConsentManagement />
      <TimeSpentTracking />
      <SiteHeader {...header} />
      <main
        className={classnames(
          styles.contentBackground,
          styles.contentBackground__trophies
        )}
      >
        <TrophyPageHeader
          displayName={user.displayName}
          username={user.username}
          points={points}
          trophyCount={trophyCount}
          trophyFilter={trophyFilter}
          handleTrophyFilterChange={handleTrophyFilterChange}
        />
        <TrophyList trophies={filteredTrophies} />
      </main>
    </ABeagleProvider>
  );
}

Page.getInitialProps = async ({ req, query }) => {
  const staticProps = { namespacesRequired: ['common'] };

  const { error, ...response } = await fetchAPI(
    // TODO: REMOVE QUERY PARAM BEFORE PROD
    `/${query.username}/trophies.json`,
    {
      req,
    }
  );

  if (error) {
    return error;
  }

  const edition = req.params.edition;
  const language = getLanguageFromEdition(edition);
  const href = `${CANONICAL_ROOT}/${language === 'en' ? '' : edition + '/'}${
    query.username
  }/trophies`;
  return {
    ...staticProps,
    ...response,
    nofollow: true,
    pageTitle: `${query.username} Trophies`,
    pageLinks: [{ rel: 'canonical', href }],
    header: query.header,
  };
};

export default withTranslation('common')(Page);
